import { useEffect, useState } from 'react';

/**
 * Loads `load(arg)`, starting from `peek(arg)` when the data is already cached
 * so revisited pages render straight away. `retry` loads again after an error.
 */
export default function useRemoteData(load, peek, arg) {
  const [state, setState] = useState(() => ({ data: peek(arg), error: null }));
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const cachedData = peek(arg);
    if (cachedData) {
      setState((s) => (s.data === cachedData ? s : { data: cachedData, error: null }));
      return undefined;
    }
    let active = true;
    setState({ data: undefined, error: null });
    load(arg).then(
      (data) => active && setState({ data, error: null }),
      (error) => active && setState({ data: undefined, error })
    );
    return () => {
      active = false;
    };
  }, [load, peek, arg, attempt]);

  return { ...state, retry: () => setAttempt((n) => n + 1) };
}
